import { useEffect, useRef } from 'react';
import { trackEvent } from '@/lib/analytics';

export const useTabTitle = () => {
  const originalTitle = useRef(document.title);

  useEffect(() => {
    const titles = [
      '🌍 Come back...',
      '💡 Your idea is waiting...',
      '🔥 HYPE misses you...',
    ];
    let interval: ReturnType<typeof setInterval>;
    let index = 0;

    const handleVisibility = () => {
      if (document.hidden) {
        interval = setInterval(() => {
          document.title = titles[index % titles.length];
          index++;
        }, 2000);
      } else {
        clearInterval(interval);
        document.title = originalTitle.current;
      }
    };

    document.addEventListener('visibilitychange', handleVisibility);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);
      clearInterval(interval);
      document.title = originalTitle.current;
    };
  }, []);
};

export const useScrollDepth = () => {
  const tracked = useRef(new Set<number>());

  useEffect(() => {
    const handler = () => {
      const total = document.documentElement.scrollHeight - window.innerHeight;
      if (total <= 0) return;
      const pct = Math.round((window.scrollY / total) * 100);
      [25, 50, 75, 100].forEach(milestone => {
        if (pct >= milestone && !tracked.current.has(milestone)) {
          tracked.current.add(milestone);
          trackEvent(`scroll_depth_${milestone}`);
        }
      });
    };
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);
};
